import React from 'react';
import bn from "../utils/bemnames";
import {ITabItem} from "../utils/types";
import classNames from "classnames";

const bem = bn.create('tabs');

interface IProps {
  items: ITabItem[];
  onStateChange: ((value: ITabItem) => void);
  pointer?: boolean;
  className?: string;
  defaultItem?: ITabItem | null;
}

interface IState {
  items: ITabItem[];
  selectedTab: ITabItem | null;
  withPointer: boolean;
  className: string;
}

class Tabs extends React.Component<IProps> {

  public readonly state: IState = {
    items: [],
    selectedTab: null,
    withPointer: false,
    className: ''
  };

  componentDidMount() {
    this.setState({
      items: this.props.items,
      selectedTab: this.props.defaultItem ? this.props.defaultItem : this.props.items[0],
      withPointer: this.props.pointer ?? true,
      className: this.props.className,
    });
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    let isPropsChanged = false
    if (prevProps.items.length !== this.props.items.length) {
      isPropsChanged = true
    } else {
      prevProps.items.forEach((item: ITabItem, index) => {
        if (item.value !== this.props.items[index].value || item.label !== this.props.items[index].label)
          isPropsChanged = true
      })
    }

    if (isPropsChanged) {
      this.setState({
        items: this.props.items,
        selectedTab: this.props.defaultItem ? this.props.defaultItem : this.props.items[0],
      });
    }
  }

  setItem = (tabItem: ITabItem) => {
    this.setState({
      selectedTab: tabItem
    });
    this.props.onStateChange(tabItem);
  };

  render() {
    const wrapperClasses = classNames({
      [bem.e('tabs-wrapper')]: true,
      [this.state.className]: this.state.className !== '',
    });

    return (
      <div className={wrapperClasses}>
        <div className={bem.e(`tabs ${this.state.withPointer ? 'with-pointer' : ''}`)}>
          <div className={bem.e('tabs__tab-list')} id="tabs">
            {this.state.items.map((item, index) => {
              return (
                <div
                  className={bem.e(`tabs__tab-list__tab ${item.value === this.state.selectedTab?.value ? (this.state.withPointer ? 'with-pointer ' : '') + 'active' : ''}`)}
                  key={index}
                  onClick={() => this.setItem(item)}
                >
                  <div className={bem.e(`tabs__tab-list__tab__tab-title`)}>{item.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default Tabs;
